export default function resetHeirarchy (name, update, state) {
  if (name === 'district') {
    let output = {
      ...update,
      school: '',
      teacher: '',
      selectedClass: '',
    }
    if (state.school || !update[name]) {
      output.nextLink = ''
    }
    return output    
  } else if (name === 'school') {
    let output = {
      ...update,
      teacher: '',
      selectedClass: '',
    }
    if (state.teacher || !update[name]) {
      output.nextLink = ''
    }
    return output
  } else if (name === 'teacher') {
    let output = {
      ...update,
      selectedClass: ''
    }
    if (state.selectedClass || !update[name]) {
      output.nextLink = ''
    }
    return output
  } else return update
}


// WEBPACK FOOTER //
// ./src/helpers/users/manageUsers/resetHeirarchy.js